import script from "./Payees.vue?vue&type=script&setup=true&lang=ts"
export * from "./Payees.vue?vue&type=script&setup=true&lang=ts"

import "./Payees.vue?vue&type=style&index=0&id=5ef35012&scoped=true&lang=css"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef35012"]])

export default __exports__